import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const MetalsInBiology_HaemoglobinChlorophyll = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Metals in Biology (Haemoglobin and Chlorophyll)"
    videos={[
      "https://www.youtube.com/embed/0ct1FCe_UJU",
      "https://www.youtube.com/embed/Amr2lozBBPE",
    ]}
    takeaways={[
      { text: "For sure one Question either chlorophyll or haemoglobin will come in CAT-1." },
      { text: "Diagram of chlorophyll and haemoglobin have to learn." },
    ]}
    questions={[
      "Discuss the role of distal histidine on the functioning of haemoglobin?",
      "Elaborate on the structure, properties and function of a plant pigment which assist the conversion of light energy into chemical energy.",
      "Why do plant leaves appear green? Explain the working mechanism involves in photosynthesis."
    ]}
    exampleVideos={[]}
  />
);
}

export default MetalsInBiology_HaemoglobinChlorophyll;
